import type { PerformanceConfig } from "./schema";
import { BASE_PACK } from "./base";

/**
 * A fixture pack, not a shipped vertical: proves that a vertical without locations can switch
 * site visits OFF (spec §7 Phase 2 item 3, plan §3.4 falsifiability). `packForVertical` never
 * returns it.
 */
export const GENERIC_OFFICE_PACK: PerformanceConfig = {
  ...BASE_PACK,
  vertical: "generic_office",
  levels: {
    ...BASE_PACK.levels,
    community: "Office lead",
    regional: "Regional lead",
  },
  terms: { ...BASE_PACK.terms, site: "Office" },
  visits: { runMinLevel: null, forms: [] },
  plans: {
    ...BASE_PACK.plans,
    levelHeading: "Disciplinary stage",
    actionExample: "Send the weekly status report by Friday noon",
  },
  retention: { ...BASE_PACK.retention, matchingRecords: "employee records" },
  coachingTypes: BASE_PACK.coachingTypes.filter((t) => t.key !== "site_visit"),
  writeBack: BASE_PACK.writeBack.filter((w) => w.what !== "Site visit"),
};
